export const ROLES = {
    Employee: 'Employee',
    Manager: 'Manager',
    Admin: 'Admin',
    Installer: 'Installer',
    LeadAssessor: 'Lead Assessor',
    Assessor: 'Assessor',
}